module.exports = __webpack_public_path__ + "img/block-menu-hikaiin01.a2770450.png";